<template>
  <div v-loading="loading" class="frame" element-loading-text="加载中...">
    <iframe ref="frameRef" :src="frameSrc" class="frame-iframe" />
  </div>
</template>
<script setup>
import { useRoute, useRouter } from "vue-router";
import {
  ref,
  unref,
  toRaw,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick
} from "vue";
import { getToken } from "@/utils/auth";
import store from "@/store";
import { ElMessage } from "element-plus";
defineOptions({
  name: "LayFrame"
});

const props = defineProps({
  frameInfo: Object
});

const loading = ref(true);
const router = useRouter();
const currentRoute = useRoute();
const frameSrc = ref("");
const frameRef = ref(null);
const FRAME_READY_TYPE = "SCHEDULING_APP_READY";
const SCHEDULING_COMMAND_TYPE = "SCHEDULING_APP_COMMAND";
const SCHEDULING_COMMAND = {
  GO_ENTRANCE: "GO_ENTRANCE",
  LOGOUT: "LOGOUT"
};
if (unref(currentRoute.meta)?.frameSrc) {
  frameSrc.value = unref(currentRoute.meta)?.frameSrc;
}

unref(currentRoute.meta)?.frameLoading === false && hideLoading();
function hideLoading() {
  loading.value = false;
}

function resolveSchedulingCommand(messageData) {
  if (!messageData) return "";

  if (messageData?.type === SCHEDULING_COMMAND_TYPE && messageData?.command) {
    return messageData.command;
  }

  // 兼容历史子应用命令格式
  if (messageData?.type === "LogOut") {
    return SCHEDULING_COMMAND.LOGOUT;
  }
  if (messageData?.type === "turnBack") {
    return SCHEDULING_COMMAND.GO_ENTRANCE;
  }

  return "";
}

function handleLogoutFromScheduling() {
  store.dispatch("userInfo/LogOut").then(() => {
    store.commit("permission/SET_SUB_SYSTEM_NAME", "");
    store.commit("permission/SET_ROUTE_TABS", []);
    store.commit("permission/SET_SUB_SYSTEM_ID", "");
    router.replace("/login");
  });
}

function handleGoEntranceFromScheduling() {
  router.push("/entrance");
}

function sendIframeMessage() {
  const iframe = unref(frameRef);
  if (!iframe?.contentWindow) return;

  let userInfo = store.getters.userInfo;
  userInfo = toRaw(userInfo);
  console.log("userInfo===>", userInfo);
  //children  frongRoute

  let menuTree = userInfo.menuTree[0].children.find(
    (ele) => ele.frongRoute === "/scheduling"
  );
  menuTree = menuTree.children ? menuTree.children : [];
  if (menuTree.length) {
    const userInfoWithMenuTree = {
      ...userInfo,
      menuTree
    };
    let params = {
      token: getToken(),
      userInfo: userInfoWithMenuTree
    };
    console.log("发送参数====>", params);
    console.log("发送参数2====>", iframe);
    iframe.contentWindow.postMessage(params, "*");
  } else {
    ElMessage({
      message: "供水调度暂无菜单,请配置供水调度菜单",
      type: "error"
    });
    router.go(-1);
  }
}
watch(
  () => currentRoute.fullPath,
  (path) => {
    if (
      currentRoute.name === "Redirect" &&
      path.includes(props.frameInfo?.fullPath)
    ) {
      frameSrc.value = path; // redirect时，置换成任意值，待重定向后 重新赋值
      loading.value = true;
    }
    // 重新赋值
    if (props.frameInfo?.fullPath === path) {
      frameSrc.value = props.frameInfo?.frameSrc;
    }
  }
);

function handleWindowMessage(e) {
  console.log("主应用接收到子应用发过来的数据====>", e);
  const iframe = unref(frameRef);
  if (!iframe?.contentWindow) return;
  if (e.source !== iframe.contentWindow) return;

  if (e.source === iframe.contentWindow && e.data?.type === FRAME_READY_TYPE) {
    sendIframeMessage();
    return;
  }

  const command = resolveSchedulingCommand(e.data);
  if (command === SCHEDULING_COMMAND.LOGOUT) {
    handleLogoutFromScheduling();
  } else if (command === SCHEDULING_COMMAND.GO_ENTRANCE) {
    handleGoEntranceFromScheduling();
  }
}

onMounted(() => {
  init();
  window.addEventListener("message", handleWindowMessage);
});

onBeforeUnmount(() => {
  window.removeEventListener("message", handleWindowMessage);
});

function init() {
  nextTick(() => {
    const iframe = unref(frameRef);

    if (!iframe) return;

    const _frame = iframe;
    if (_frame.attachEvent) {
      _frame.attachEvent("onload", () => {
        hideLoading();
        setTimeout(() => {
          // 兜底：若子应用没有主动发READY，也至少尝试发送一次初始化参数
          sendIframeMessage();
        }, 500);
      });
    } else {
      iframe.onload = () => {
        hideLoading();
        setTimeout(() => {
          // 兜底：若子应用没有主动发READY，也至少尝试发送一次初始化参数
          sendIframeMessage();
        }, 500);
      };
    }
  });
}
</script>

<style lang="scss" scoped>
.frame {
  position: absolute;
  inset: 0;
  overflow: hidden;
  .frame-iframe {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 0;
  }
}
</style>

